export const baseUrl = process.env.NODE_ENV === 'production' ?
    process.env.REACT_APP_FRONTEND_PRODUCTION_URL :
    process.env.REACT_APP_FRONTEND_DEVELOPMENT_URL;

/**********************************************************************************************************************/

export const logout = () => {
    localStorage.removeItem('AdminToken');
    window.location.reload();
}

export const formatDateDMY = (sqlDate) => {
    const date = new Date(sqlDate);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
}
